export default "__VITE_ASSET__Da9Ty8rr__"